import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { sortDataTablesByNumericThenAlpha } from '@awp/helpers/sorter';
import Table from '@awp/components/table';

const LegendModal = ({ legend, setLegend }) => {
  const handleCancel = () => {
    setLegend([]);
  };

  const TableColumns = useMemo(() => [
    {
      Header: 'Value',
      accessor: 'OBSERVED_CHARACTER_VALUE',
      sortType: sortDataTablesByNumericThenAlpha,
    },
    {
      Header: 'Meaning',
      accessor: 'DISPLAYED_MEANING',
      sortType: sortDataTablesByNumericThenAlpha,
    },
    {
      Header: 'Hint',
      accessor: 'DISPLAYED_HINT',
      sortType: sortDataTablesByNumericThenAlpha,
    },
    {
      Header: 'DISPLAY_ORDER',
      accessor: 'DISPLAY_ORDER',
      //sortType: sortByNumericThenAlpha,// do not imple this line as the sort type has been defined in defaultSortBy
    },
  ]);

  return (
    <Modal size="lg" show={legend && legend.length > 0} onHide={handleCancel}>
      <Modal.Body style={{ fontSize: '0.85em' }}>
        <h3>Legend</h3>
        <div className="dataTables-table dataTables overflow-auto table-sm">
          <Table
            columns={TableColumns}
            data={legend}
            fetchData={() => {}}
            search=""
            filters={[]}
            dataTriggers={[]}
            defaultSortBy={'DISPLAY_ORDER'}
            defaultDesc={false}
            hiddenColumns={['DISPLAY_ORDER']}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

LegendModal.propTypes = {
  legend: PropTypes.array,
  setLegend: PropTypes.func,
};

export default LegendModal;
